import { createFileRoute } from '@tanstack/react-router';
import { ApiKeysIndex } from '@/pages/settings/api-keys/ApiKeysIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/api-keys')({
	beforeLoad: async ({ context }) => {
		await requireAnyPermission({ context, anyOf: ['companySettings.manageApiKeys'] });
	},
	component: ApiKeysIndex,
});
